import "./donatenow.scss";
import { useState } from "react";
import QR from "../../asserts/images/qr1.jpeg";
import donateImg from "../../asserts/images/donate_img.png";
import forward from "../../asserts/images/forward.svg";
import { Link } from "react-router-dom";


const DonateNow = () => {
    const [amount, setAmount] = useState(500);
    const [frequency, setFrequency] = useState("monthly"); // 'once' or 'monthly'

    return (
        <div className="container donate-now-container my-5">
            <p className="path">
                <Link to="/home">Home</Link> <img src={forward} className="pb-1" />
                Donate Now
            </p>
            <h1 className="page-title mb-5">
                Your Donation, Every Meal <br /> Changes a Life.
            </h1>

            <div className="row g-5">
                {/* Left Side Image */}
                <div className="col-lg-7 col-md-12">
                    <img src={donateImg} alt="Smiling children" className="img-fluid rounded-4 main-image" />
                </div>

                {/* Right Side Donation Card */}
                <div className="col-lg-5 col-md-12">
                    <div className="donation-card shadow p-4 rounded-4 bg-white">
                        {/* Frequency Tabs */}
                        {/* <div className="d-flex justify-content-center mb-4 tabs">
                            <button
                                className={`btn tab-btn ${frequency === "once" ? "active" : ""}`}
                                onClick={() => setFrequency("once")}
                            >
                                Give Once
                            </button>
                            <button
                                className={`btn tab-btn ${frequency === "monthly" ? "active" : ""}`}
                                onClick={() => setFrequency("monthly")}
                            >
                                Give Monthly
                            </button>
                        </div>

                        <div className="text-center mb-3">
                            <p className="text-muted mb-1">Donate {frequency === "monthly" ? "Monthly" : "Once"}</p>
                            <h2 className="amount-display">₹ {amount}</h2>
                            <p className="text-muted small">25 Meals</p>
                        </div> */}

                        {/* Amount Buttons */}
                        {/* <div className="d-flex justify-content-between gap-2 mb-3">
                            {[200, 500, 800].map((val) => (
                                <button
                                    key={val}
                                    className={`btn amount-btn ${amount === val ? "active" : ""}`}
                                    onClick={() => setAmount(val)}
                                >
                                    ₹ {val}
                                </button>
                            ))}
                        </div> */}

                        {/* Custom Amount */}
                        {/* <div className="mb-4">
                            <label className="form-label small fw-bold">Enter Your Amount</label>
                            <input
                                type="number"
                                className="form-control"
                                placeholder="Enter amount"
                                value={amount}
                                onChange={(e) => setAmount(Number(e.target.value))}
                            />
                        </div> */}

                        {/* Continue Button */}
                        {/* <button className="btn btn-success w-100 continue-btn py-2 mb-3">
                            Continue
                        </button> */}

                        {/* Disclaimer */}
                        {/* <p className="disclaimer-text text-muted">
                            Donations must be made to recognized charities or NGOs with 80G certification.<br />
                            By donating you are agreeing to our <a href="#">Privacy Policy</a> and <a href="#">Terms of Use</a>
                        </p> */}
                        <img src={QR} alt="" className="img-fluid mb-4" />

                        {/* Bank Details Section */}
                        <div className="bank-details text-start p-3 bg-light rounded-3">
                            <h5 className="fw-bold mb-3 text-center" style={{ color: '#5A862E' }}>Bank Account Details</h5>
                            <p className="mb-2"><strong>Account Name:</strong> Pagirndhunn Charitable Trust</p>
                            <p className="mb-2"><strong>Account Number:</strong> 43822288074</p>
                            <p className="mb-2"><strong>IFSC Code:</strong> SBIN0000924</p>
                            <p className="mb-2"><strong>Bank Name:</strong> SBI</p>
                            <p className="mb-0"><strong>UPI ID:</strong> pagirndhunncharitabletrust@sbi</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom Text Section */}
            <div className="row mt-5">
                <div className="col-12">
                    <h2 className="mb-4 section-title">How will your <br /> donations be used?</h2>
                    <ol className="usage-list text-muted ps-3">
                        <li className="mb-2">Cost Per Meal: The average cost to prepare one meal is Rs. 15.</li>
                        <li className="mb-2">Program Objective: The Daily Feeding Program partners with credible non-profits and low-income schools in the education sector.</li>
                        <li className="mb-2">Need Assessment: Proper assessments are conducted to understand the specific requirements of the associations.</li>
                        <li className="mb-2">Carefully Designed Menu: Meals are tailored to meet the local palate and nutritional needs.</li>
                        <li className="mb-2">Program Monitoring: Attendance and nutritional assessments are closely monitored to evaluate impact.</li>
                        <li className="mb-2">Food as a Catalyst: The program ensures food complements education and drives positive change for beneficiaries.</li>
                    </ol>
                </div>
            </div>
        </div>
    );
};

export default DonateNow;
